import {View} from "@unibuddy/patron";
import {AmboInboxHeader} from "./AmboInboxHeader";
import {AdminInbox} from "../AdminInbox/AdminInbox";
import {UniversalInbox, UniversalInboxProps} from "../UniversalInbox/UniversalInbox";
import {useState} from "react";

export const AmboInbox = ({onSelect}: UniversalInboxProps) => {
    const [showUniversalInbox, setShowUniversalInbox] = useState(false);
    return (
        <View flex="1">
            <AmboInboxHeader
                showUniversalInbox={showUniversalInbox}
                setShowUniversalInbox={setShowUniversalInbox}
            />
            {showUniversalInbox ? (
                <UniversalInbox onSelect={onSelect} />
            ) : (
                <AdminInbox onSelect={onSelect} />
            )}
        </View>
    );
};
